import { render, staticRenderFns } from "./ViewSubscriptionComponent.vue?vue&type=template&id=38ca8890"
import script from "./ViewSubscriptionComponent.vue?vue&type=script&lang=js"
export * from "./ViewSubscriptionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports